import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { UserOutput } from "~@/graphql/codegen/generated";

export enum CreationType {
  User = "user",
  Event = "event",
}

export interface EventCreationState {
  creationType: CreationType;
  newClient?: UserOutput;
}

const initialState: EventCreationState = {
  creationType: CreationType.Event,
  newClient: undefined,
};

const eventCreationSlice = createSlice({
  name: "eventCreation",
  initialState,
  reducers: {
    setCreationType: (state, action: PayloadAction<CreationType>) => {
      state.creationType = action.payload;
    },
    setNewClient: (state, action: PayloadAction<UserOutput | undefined>) => {
      state.newClient = action.payload;
    },
    resetEventCreationState: () => initialState,
  },
});

export const { setCreationType, setNewClient, resetEventCreationState } =
  eventCreationSlice.actions;

export default eventCreationSlice.reducer;
